import React from "react";
import { Link } from "react-router-dom";
import Projects from "../../api/projects";

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handlemail = () => {
    const mailto =
      "mailto:iserenify@gmail.com?subject=theOilsBabe - Informatii&body= ";
    window.location.href = mailto;
  };

  const handletel = () => {
    const telto = "tel:+40743222996";
    window.location.href = telto;
  };

  const handleWhatsApp = () => {
    const whatsappUrl = "https://wa.me/40743222996";
    window.location.href = whatsappUrl;
  };

  return (
    <footer className="wpo-site-footer">
      <div className="footer-wave">
        <svg
          viewBox="0 0 1440 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#904d71" 
            fillOpacity="1"
            d="M0,128L40,138.7C80,149,160,171,240,165.3C320,160,400,140,480,134.7C560,129,640,139,720,149.3C800,160,880,160,960,154.7C1040,149,1120,139,1200,138.7C1280,139,1360,149,1400,154.7L1440,160V320H0Z"
          ></path>
        </svg>
      </div>

      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            {/* <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12"> */}
            <div className="widget about-widget">
              <div className="logo widget-title">
                <Link onClick={ClickHandler} className="logo" to="/">
                  <img src="../logo/logo complet alb tm.png" />
                </Link>
              </div>
              {/* <p>Make your dreams come true.</p> */}

              {/* <ul>
                                <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-facebook"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-twitter-alt"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-instagram"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-google"></i>
                                    </Link>
                                </li>
                            </ul> */}
            </div>
            {/* </div> */}
            {/* <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget link-widget">
                            <div className="widget-title">
                                <h3>Information</h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                <li><Link onClick={ClickHandler} to="/portfolio">Portfolio</Link></li>
                                <li><Link onClick={ClickHandler} to="/blog">Latest News</Link></li>
                                <li><Link onClick={ClickHandler} to="/contact">Contact us</Link></li>
                                <li><Link onClick={ClickHandler} to="/service">Our Services</Link></li>
                            </ul>
                        </div>
                    </div> */}
            {/* <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12"> */}
            {/* <div className="widget wpo-service-link-widget"> */}
            {/* <div className="widget-title">
                  <h3>Contact </h3>
                </div> */}
            {/* <div className="contact-ft"> */}
            {/* <p>
              Dacǎ ai nevoie de ajutor, nu ezita sǎ ne contactezi!
            </p> */}
            {/* <ul>
                    <li>Ariana Henzel</li>
                    <li onClick={handlemail} className="custom-email-icon">
                      <i className="fi flaticon-email"></i>
                      iserenify@gmail.com
                    </li>
                    <li onClick={handletel} className="custom-tel-icon">
                      <i className="fi flaticon-phone-call"></i>+40 748 958 596
                    </li>
                    <li>
                      <i className="fi flaticon-maps-and-flags"></i>Sibiu,
                      Romania
                    </li>
                  </ul> */}

            {/* </div> */}

            {/* </div> */}

            {/* </div> */}
            <div className="footer">
              <section className={`social-section-footer section-padding `}>
                <div className="social-wrap-footer">
                  <div className="social-item-footer">
                    <div className="social-text-footer">
                      <ul>
                      <li>
                          <a onClick={handleWhatsApp}>
                            <i className="fi flaticon-new-whatsapp"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.facebook.com/ariana.henzel1"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fi flaticon-facebook-app-symbol"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/ariana.henzel?igsh=MTN3MDJ0dTJ1am16Mg=="
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fi flaticon-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a onClick={handlemail}
                          >
                            <i className="fi flaticon-email"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            {/* <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget instagram">
                            <div className="widget-title">
                                <h3>Instagram</h3>
                            </div>
                            <ul className="d-flex">
                                {Projects.slice(0,6).map((project, pitem) => (
                                    <li key={pitem}><Link onClick={ClickHandler} to={`/project-single/${project.id}`}><img src={project.pimg1} alt=""/></Link></li>
                                ))}
                            </ul>
                        </div>
                    </div> */}

            {/* <div style={{ textAlign: "center" }}>
              <Link onClick={ClickHandler} to="/home">
                <img
                  src="../iserenify_logo_white_drop.png"
                  alt="logo"
                  style={{ width: 120 }}
                />
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                {" "}
                &copy; 2024 theoilsbabe. Design creat de{" "}
                <Link onClick={ClickHandler} to="/">
                  Claudiu Popa
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
